export default [
    {
        name: 'font',
        type: 'font',
        path: "font/helvetiker_regular.typeface.json"
    },
    {
        name: 'redTile',
        type: 'gltfModel',
        path: "models/red.gltf"
    },
    {
        name: 'birchTile',
        type: 'gltfModel',
        path: "models/birch.gltf"
    },
    {
        name: 'base',
        type: 'gltfModel',
        path: "models/base.gltf"
    },
]

// {x: -3.0500006675720215, y: 0.25972655415534973, z: 3.0500011444091797}